import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Typography,
  useTheme,
} from '@mui/material';
import { Warning2 } from 'iconsax-react';
import type { FC } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  companyName: string;
  onSaveAsDraft?: () => void;
};
export const CompanyWithoutDispatchModel: FC<Props> = ({
  isOpen,
  onClose,
  companyName,
  onSaveAsDraft,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      sx={{
        '& .MuiDialog-paper': {
          width: '900px',
          maxWidth: 'calc(100vw - 64px)',
        },
      }}
    >
      <DialogTitle variant='h4' sx={{ fontWeight: 500 }} id='alert-dialog-title'>
        Company Without Dispatch System
      </DialogTitle>
      <DialogContent>
        <Box gap={2} display='flex' flexDirection='column'>
          <Alert severity='warning' icon={<Warning2 variant='TwoTone' />} sx={{ borderRadius: 2 }}>
            {companyName} is not linked to dispatch. Create this customer in your dispatch system,
            then link them in Slabstack to export.
          </Alert>

          <Box>
            <Typography variant='h5/medium'>Resolution Steps:</Typography>
            <List
              sx={{
                color: theme.palette.SlabGray[600],
                listStyleType: 'disc',
                pl: 3,
                '& .MuiListItem-root': {
                  display: 'list-item',
                  pl: 1,
                },
              }}
            >
              <ListItem>
                <Typography variant='h6/medium'>{`Add "${companyName}" to a dispatch system`}</Typography>
              </ListItem>
              <ListItem>
                <Typography variant='h6/medium'>Wait for sync (~20 minutes)</Typography>
              </ListItem>
              <ListItem>
                <Typography variant='h6/medium'>Return to export this quote</Typography>
              </ListItem>
            </List>
          </Box>
        </Box>
      </DialogContent>
      <Box
        sx={{
          display: 'flex',
          gap: 1.5,
          px: 3,
          py: 2,
        }}
      >
        <Button variant='slab-secondary' sx={{ flex: 1 }} onClick={onClose}>
          Cancel
        </Button>

        {onSaveAsDraft ? (
          <Button variant='slab-secondary' sx={{ flex: 1 }} onClick={onSaveAsDraft}>
            Save as Draft
          </Button>
        ) : (
          <Button variant='slab-primary' sx={{ flex: 1 }} onClick={onClose}>
            I&apos;ll do it later
          </Button>
        )}
      </Box>
    </Dialog>
  );
};
